import React from "react";

// Rede de seguranca da tela. Sem ela, qualquer erro dentro de um componente
// derrubava a pagina INTEIRA (tela branca, sem menu, sem lista) e nao sobrava
// nenhuma pista do que aconteceu -- so dava para descobrir abrindo o console do
// navegador. Aqui o erro fica preso na parte da tela que quebrou, o resto
// continua funcionando, e a mensagem aparece escrita para a pessoa mandar um
// print para o suporte.
class ErroNaTela extends React.Component {
  constructor(props) {
    super(props);
    this.state = { erro: null, onde: "" };
  }

  static getDerivedStateFromError(erro) {
    return { erro };
  }

  componentDidCatch(erro, info) {
    const pilha = String(info?.componentStack || "");
    const onde = (pilha.match(/in (\w+)/g) || [])
      .slice(0, 3)
      .map((t) => t.replace("in ", ""))
      .join(" › ");
    this.setState({ onde });
    // eslint-disable-next-line no-console
    console.error("[ErroNaTela]", this.props.nome || "", erro, pilha);
  }

  componentDidUpdate(anterior) {
    // Trocou de atendimento: tenta de novo do zero.
    if (anterior.chave !== this.props.chave && this.state.erro) {
      this.setState({ erro: null, onde: "" });
    }
  }

  render() {
    const { erro, onde } = this.state;
    if (!erro) return this.props.children;

    const texto = String(erro?.message || erro);

    return (
      <div
        style={{
          height: "100%",
          minHeight: 260,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 24,
          boxSizing: "border-box",
        }}
      >
        <div
          style={{
            maxWidth: 440,
            width: "100%",
            borderRadius: 14,
            border: "1px solid rgba(220,38,38,0.25)",
            background: "rgba(220,38,38,0.05)",
            padding: "20px 22px",
            fontFamily: "inherit",
          }}
        >
          <div style={{ fontWeight: 800, fontSize: "1rem", color: "#b91c1c", marginBottom: 6 }}>
            {this.props.titulo || "Não foi possível abrir esta parte da tela"}
          </div>
          <div style={{ fontSize: "0.85rem", lineHeight: 1.5, opacity: 0.85, marginBottom: 12 }}>
            Tente recarregar a página. Se continuar acontecendo, mande um print
            desta mensagem para o suporte.
          </div>
          <div
            style={{
              fontFamily: "monospace",
              fontSize: "0.75rem",
              background: "rgba(0,0,0,0.05)",
              borderRadius: 8,
              padding: "8px 10px",
              wordBreak: "break-word",
              marginBottom: 14,
            }}
          >
            {texto}
            {onde ? <div style={{ opacity: 0.7, marginTop: 4 }}>em: {onde}</div> : null}
          </div>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            <button
              type="button"
              onClick={() => this.setState({ erro: null, onde: "" })}
              style={{
                border: "1px solid #d0d5dd",
                background: "transparent",
                borderRadius: 8,
                padding: "7px 14px",
                cursor: "pointer",
                fontWeight: 600,
              }}
            >
              Tentar de novo
            </button>
            <button
              type="button"
              onClick={() => window.location.reload()}
              style={{
                border: "none",
                background: "#0D9488",
                color: "#fff",
                borderRadius: 8,
                padding: "7px 14px",
                cursor: "pointer",
                fontWeight: 600,
              }}
            >
              Recarregar página
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default ErroNaTela;
